import {
  AfterViewChecked, Component, ComponentRef, EventEmitter,
  Input, OnInit, Output, Type, ViewChild, ViewContainerRef
} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {FancyButtonComponent} from "../../fancy-button/fancy-button.component";
import {NavigationBoxComponent} from "../../navigation-box/navigation-box.component";
import {ProgressComponent} from "../../progress/progress.component";
import {SvgIconComponent} from "../../svg-icon/svg-icon.component";

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [
    NgIf,
    FancyButtonComponent,
    NgTemplateOutlet,
    NavigationBoxComponent,
    ProgressComponent,
    SvgIconComponent,
    NgClass
  ],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.scss',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: `{{from}}`}),
        animate('200ms ease-in', style({transform: ''}))
      ],{params:{ from: ""}}),
      transition(':leave', [
        animate('200ms ease-in', style({transform: `{{to}}`})),
      ],{params:{ to: ""}})
    ])
  ]
})
export class PopupComponent implements OnInit, AfterViewChecked {
  @Input() public isOpen = false;
  @Output() public isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public confirmed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input({ required: true }) public dynamicComponent!: Type<any>;
  @Input() public data: any;
  @Input() public readonly: boolean = false;
  @Input() public from: string = "";
  @Input() public to: string | null = null;
  @Input() public withBlur: boolean = false;


  @ViewChild('container', {read: ViewContainerRef, static: false}) protected container!: ViewContainerRef;
  protected component?: ComponentRef<any>;

  ngOnInit() {
    this.to ??= this.from;
  }

  ngAfterViewChecked() {
    this.create()
  }

  protected create() {
    if (this.container && this.dynamicComponent && !this.component) {
      this.container.clear();
      this.component = this.container.createComponent(this.dynamicComponent);
      this.component.instance.data = this.data;
      this.component.instance.readonly = this.readonly;
      this.component.location.nativeElement.addEventListener('click', (e: MouseEvent) => {
        e.stopPropagation()
      })
      this.component.instance.closeEvent?.subscribe((confirmed:boolean) => {
        this.close(confirmed);
      })
    }
  }

  protected close(confirmed: boolean) {
    this.component = undefined;
    this.isOpen = false;
    this.isOpenChange.emit(false);
    this.confirmed.emit(confirmed);
  }
}
